import { configureStore } from "@reduxjs/toolkit";
import { rootReducer, actions } from "surveillance-binder";
const store = configureStore({
  reducer: rootReducer,
});

export { actions, store };
